<template>
    <div>
        <!-- Main Modal -->
        <div ref="spareProductList" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modelSingle" aria-hidden="true">
            <div class="modal-dialog modal-l" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>ระบุอะไหล่ซัพพลายเออร์</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="kt-portlet__body">
                            <div class="kt-section kt-section--first">
                                <div class="row">
                                    <div class="col-xl-12">
                                        <div v-for="(group, index) in items" :key="index" class="mb-4">
                                            <!-- ✅ หัวข้อชื่อสินค้า -->
                                            <h5 class="text-primary mb-2">ชื่อสินค้า : {{ group.materialName }} [{{group.materialCode}}]</h5>

                                            <!-- ✅ Table Header -->
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 80px;text-align:center;">ลำดับ</th>
                                                        <th style="text-align:center;">{{ getBarcodeHeader(group) }}</th>
                                                        <th style="width: 150px;text-align:center;">ระบุรายการอะไหล่</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(barcode, i) in group.barcodeSpareUseds" :key="i">
                                                        <td style="text-align:center;">{{i+1}}</td>
                                                        <td style="text-align:center;">{{ barcode.barcodeNoOld }}</td>
                                                        <td style="text-align:center;">
                                                            <a class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ระบุรายการอะไหล่" @click="openSparePartModal(group,barcode)">
                                                                <i class="fa fa-wrench" aria-hidden="true"
                                                                   style="color: #a7abc3;"></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div> <!-- end row -->
                                <div class="row">
                                    <div class="col-xl-12">
                                        <div class="form-check">
                                            <label class="form-check-label kt-checkbox">
                                                <input id="isSpareAdded"
                                                       name="isSpareAdded"
                                                       v-model="isSpareAdded"
                                                       type="checkbox"
                                                       class="form-check-input" />
                                                เพิ่มอะไหล่เรียบร้อยแล้ว
                                                <span></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="kt-portlet__foot">
                            <button type="button" data-dismiss="modal" class="btn btn-secondary"><i class="la la-close"></i> ย้อนกลับ</button>
                            <button type="button" data-dismiss="modal" class="btn btn-primary" @click.prevent="btnAddSpareParts()"><i class="la la-save"></i> บันทึกข้อมูล</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Sub Modal -->
        <spare-part-used-list ref="sparePartUsedList"
                          :barcode="selectedBarcode"
                          :spare-parts="selectedBarcode && selectedBarcode.spareParts || []"
                          @save="handleSparePartSave" />

    </div>

</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import sparePartUsedList from './JobAddSpareUsedList.vue'

export default {
    components: {
        sparePartUsedList
    },
  data: function() {
    return {
      uuid: "",
      job: {},
      isEditable:null,
      jobNumber:null,
      jobTypeName:null,
      jobStatus:null,
      items: [],
      isSpareAdded: false,
      selectedBarcode: {},
      selectedGroup: {},
      jobSparePartUsedList:[] // for send data to save
    };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();
      },

      openSparePartModal(group,barcode) {
          this.selectedBarcode = barcode;
          this.selectedGroup = group;
          this.$refs.sparePartUsedList.open(barcode);
      },

      handleSparePartSave(updatedList) {
          // อัปเดตรายการอะไหล่ของ barcode ที่เลือก
          console.log("BarcodeNo : " + this.selectedBarcode.barcodeNoOld);

          this.selectedBarcode.sparePartUsedItems = []; // reset spare used before add new.
          let sumSpareUsedQty = 0;

          //=== must filter only qty != 0
          for (let i = 0; i < updatedList.length; i++) {
              const item = updatedList[i];
              
              if (item.qty != 0) {
                  if (this.selectedBarcode.barcodeId == 0) {
                      // Case : No have barcode
                      sumSpareUsedQty += item.qty;
                  }
                  this.selectedBarcode.sparePartUsedItems.push({
                      
                      //jobSparePartUsedId: 0,
                      jobId: this.job.jobId,
                      jobItemId: this.selectedGroup.jobItemId,
                      repairMaterialCode: this.selectedBarcode.materialCode,
                      barcodeId: this.selectedBarcode.barcodeId,
                      spareMaterialCode: item.materialCode,
                      spareUsedQty: item.qty 
                  });
              }
          }
          if (this.selectedBarcode.barcodeId == 0)
            this.selectedBarcode.barcodeNoOld = sumSpareUsedQty; // To show sum QTY case No have barcode.
      },

    showModal(jobData){
    let self = this;
    self.items = []; // reset array
    // Find JobItem then push to items[]

        // set isSpareAdded from job
        self.isSpareAdded = jobData.isSpareAdded;

    var url = "/Api/Jobs/FindJobItem/?id=" + jobData.jobId;
      axios
        .get(url)
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data;
            self.isEditable = data.isEditable;
            self.jobNumber = data.jobNumber;
            self.jobTypeName = data.jobTypeName;
            self.jobStatus = data.jobStatus;
            
            
            for (let i = 0; i < data.items.length; i++) {
                let item = data.items[i];
                
                //=== must filter only qty != 0
                //for (let j = 0; j < item.barcodeSpareUseds.length; j++) {
                //    let barcodeItem = item.barcodeSpareUseds[j];
                //    // Set QTY for No have Barode
                //    if (barcodeItem.barcodeId == 0) { 
                //        let sumSpareUsedQty = 0;
                //        for (let k = 0; k < barcodeItem.sparePartUsedItems.length; k++) {
                //            let usedItem = barcodeItem.sparePartUsedItems[k];
                //            sumSpareUsedQty += usedItem.spareUsedQty;
                //        }
                //        barcodeItem.barcodeNoOld = sumSpareUsedQty;
                //    }
                //}
                item.barcodeSpareUseds.forEach(barcodeItem => {
                    if (barcodeItem.barcodeId === 0) {
                        barcodeItem.barcodeNoOld = barcodeItem.sparePartUsedItems.reduce(
                            (sum, usedItem) => sum + (usedItem.spareUsedQty || 0),
                            0
                        );
                    }
                });


                self.items.push({
                    jobItemId: item.jobItemId,
                    materialCode: item.materialCode,
                    materialName: item.materialName,
                    description: item.description,
                    quantity: item.quantity,
                    checkedQuantity: item.checkedQuantity,
                    unitName: item.baseUnit,
                    hasBarcode: item.hasBarcode,
                    isDisabled: item.isDisabled,
                    barcodes: item.barcodes,
                    barcodeSpareUseds: item.barcodeSpareUseds
                });
            }

          } else {
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลลูกค้าที่คุณเลือก", "warning");
            KTApp.unblockPage();
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
          KTApp.unblockPage();
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
      }
      ,
      btnAddSpareParts: function () {
          var self = this;

          //=== Prepare jobSparePartUsedList
          this.jobSparePartUsedList = []; // reset list

          // loop set spare used item
          // items -> barcodeSpareUseds -> sparePartUsedItems
          this.items.forEach(item => {
              if (item.barcodeSpareUseds && item.barcodeSpareUseds.length > 0) {
                  item.barcodeSpareUseds.forEach(used => {
                      if (used.sparePartUsedItems && used.sparePartUsedItems.length > 0) {
                          used.sparePartUsedItems.forEach(spare => {
                              this.jobSparePartUsedList.push(spare);
                          });
                      }
                  });
              }
          });

          console.log("รวมทั้งหมด:", this.jobSparePartUsedList.length, "รายการ");
          console.table(this.jobSparePartUsedList);

          // -- Begin Add Spare
          KTApp.blockPage({
              opacity: 0.05,
              message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
          });
          axios
              .post("/Api/Jobs/AddSpareParts", {
                  jobId: self.job.jobId,
                  isSpareAdded: self.isSpareAdded , // self.job.isSpareAdded,
                  jobSparePartUsedList: self.jobSparePartUsedList 
              })
              .then(function (response) {
                  if (response.data.status) {

                      // set isSpareAdded back to jobData if success
                      self.job.isSpareAdded = self.isSpareAdded;

                      Swal.fire("สำเร็จ", response.data.message, "success");
                      self.$parent.reloadDataTable();
                      $(self.$el).modal("hide");
                  } else {
                      let msg = response.data.message;
                      
                      Swal.fire({
                          title: "เกิดข้อผิดพลาด",
                          html: msg,
                          type: "error",
                          showCancelButton: true,
                          confirmButtonText:
                              "<i class='fa fa-archive'></i> ฉันต้องการปิดใบงานนี้",
                          cancelButtonText: "ตรวจสอบข้อมูล"
                      }).then(result => {
                          if (result.value) {
                              self.commitJob(true);
                          }
                      });
                  }
              })
              .catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
              })
              .then(function () {
                  // always executed
                  KTApp.unblockPage();
              });
          // -- End Commit Job
      }
      ,
      getBarcodeHeader(group) {
          if (!group.barcodeSpareUseds || group.barcodeSpareUseds.length === 0)
              return 'Barcode';
          return group.barcodeSpareUseds[0].barcodeId === 0 ? 'จำนวน' : 'Barcode';
      }
  },
  mounted() {
    let self = this;
    self.uuid = self.$uuid.v1();
    
    $(self.$refs.modal).on("hidden.bs.modal", function() {
      self.uuid = self.$uuid.v1();
      self.job = {};
    });

    

  }
};
</script>

<style lang="scss" scoped>
.table td {
    padding: 0.1rem;
    vertical-align: middle;
}
.table th {
    padding: 0.5rem;
    vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// App/Components/Job/JobAddSpareProductList.vue